import LeadCreate from "./leadCreate"

export default LeadCreate
